<template>
  <div ref="modal">
    <div
      id="catalogShareModal"
      ref="catalogShareModal"
      class="modal fade catalog-share-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="catalogShareModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl catalog-share-modal__dialog"
        role="document"
      >
        <div class="modal-content catalog-share-modal__content">
          <div class="modal-header catalog-share-modal__header">
            <div class="catalog-share-modal__header-content">
              <h5
                id="catalogShareModalLabel"
                class="modal-title catalog-share-modal__title"
              >
                Share Flipbook
              </h5>

              <p class="catalog-share-modal__description">
                Copy the link or share the QR code so anyone can view this Flipbook on their device.
              </p>
            </div>

            <button
              type="button"
              class="close catalog-share-modal__close"
              aria-label="Close"
              @click="closeHandler"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body catalog-share-modal__body">
            <div class="input-group catalog-share-modal__link-group">
              <input
                :value="shareUrl"
                type="text"
                class="form-control catalog-share-modal__link-input"
                readonly
              >

              <button
                type="button"
                class="btn btn-primary catalog-share-modal__copy-button"
                @click="copyLink"
              >
                <i class="fa fa-copy" />
                Copy
              </button>
            </div>

            <div class="catalog-share-modal__qr">
              <img
                v-if="qrUrl"
                :src="qrUrl"
                class="catalog-share-modal__qr-image"
                alt="Catalog QR code"
              >

              <div class="catalog-share-modal__qr-content">
                <div class="catalog-share-modal__qr-title">
                  <i class="bi bi-qr-code catalog-share-modal__qr-icon" />
                  Scan to open on a phone
                </div>

                <p class="catalog-share-modal__qr-description">
                  Great for trade shows or printed collateral.
                </p>
              </div>

              <button
                type="button"
                class="btn catalog-share-modal__download-button"
                @click="downloadQr"
              >
                Download PNG
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: "CatalogShareModal",
  props: {
    catalog: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      qrUrl: null,
      eventCatalog: null,
    };
  },
  computed: {
    activeCatalog() {
      return this.eventCatalog || this.catalog;
    },
    shareUrl() {
      return this.activeCatalog?.slug
        ? `${window.location.origin}/catalogs/${this.activeCatalog.slug}`
        : '';
    },
  },
  mounted() {
    window.addEventListener('open-catalog-share', this.handleOpen);
  },
  beforeDestroy() {
    window.removeEventListener('open-catalog-share', this.handleOpen);
  },
  methods: {
    async init() {
      if (!this.shareUrl) return;

      this.qrUrl = await QRCode.toDataURL(this.shareUrl, {
        width: 180,
        margin: 0,
      });

      $(this.$refs.catalogShareModal).modal('show');
    },
    async handleOpen(event) {
      this.eventCatalog = event.detail || {};
      await this.init();
    },
    closeHandler() {
      $(this.$refs.catalogShareModal).modal('hide');
    },
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.shareUrl);
        toastr.success('Flipbook link copied');
      } catch (e) {
        console.error('Clipboard copy failed:', e);
        toastr.error('Failed to copy link. Please copy it manually.');
      }
    },
    async downloadQr() {
      if (!this.qrUrl || !this.activeCatalog?.slug) return;

      const link = document.createElement('a');
      link.href = this.qrUrl;
      link.download = `catalog-qr-${this.catalog.slug}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
};
</script>

<style scoped lang="scss">
.catalog-share-modal {
  &__dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 1rem;
    margin: 0 auto;
  }

  &__content {
    position: relative;
    max-width: 28rem;
    padding: 1.5rem;
  }

  &__header {
    padding: 0 0 1rem;
    border: 0;
  }

  &__header-content {
    padding-right: 1rem;
  }

  &__title {
    font-size: 1.125rem;
    line-height: 1rem;
    font-weight: 600;
    letter-spacing: -0.025em;
  }

  &__description {
    margin: 0.375rem 0 0;
    color: #64748b;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  &__close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 1.25rem;
    line-height: 1;
  }

  &__body {
    padding: 0;
  }

  &__link-group {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &__link-input {
    height: auto;
    padding: 0.5rem 0.75rem;
    background-color: #fff;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  &__copy-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
  }

  &__qr {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: .75rem;
    margin-top: 1.25rem;
    padding: 1.25rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
  }

  &__qr-image {
    display: block;
    padding: .75rem;
  }

  &__qr-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: .25rem;
  }

  &__qr-icon {
    font-size: 1rem;
  }

  &__qr-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    font-size: .75rem;
    line-height: 1rem;
    font-weight: 500;
  }

  &__qr-description {
    margin: 0;
    color: #64748b;
    font-size: 11px;
  }

  &__download-button {
    height: 2.25rem;
    padding: 0 0.75rem;

    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;

    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    background-color: #fff;
    color: #000;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;

    transition: all 0.2s ease;

    &:hover,
    &:focus {
      color: #fff;
      background-color: #209c86;
      border-color: #209c86;
    }
  }
}
</style>